import {useState} from 'react'
import {ModalBase} from '../ModalBase'
import CamposMotivoAnulacion, {MOTIVO_ANULACION_POR_DEFECTO, MotivoAnulacion, motivoAnulacionEsValido} from './CamposMotivoAnulacion'

const ModalAnularFactura = (props: any) => {
  const [motivo, setMotivo] = useState<MotivoAnulacion>({...MOTIVO_ANULACION_POR_DEFECTO})
  const puedeAnular = motivoAnulacionEsValido(motivo)

  return (
    <ModalBase>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h2 className='card-title l'>{'Anular documento'}</h2>
          </div>
          <div className='form-separator'></div>
          <p className='m'>
            Estás a punto de anular lo siguiente, ¿deseas continuar?
          </p>
          {
            props.detail && (<p className='m'><b>Documento(s):</b> {props.detail}</p>)
          }
          <div className='form-separator'></div>
          <CamposMotivoAnulacion motivo={motivo} onChange={setMotivo} />
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button
              className='m button transparent w-inline-block'
              onClick={props.closeModalEliminar}
            >
              <div>Cancelar</div>
            </button>
            <button 
              className='m button delete w-inline-block' 
              disabled={!puedeAnular}
              onClick={() => props.actionEliminar(motivo)}
            >
              <div>Anular</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalAnularFactura
